export default __webpack_public_path__ + "static/media/qwcx.d19c8979.png";